export default __webpack_public_path__ + "static/media/watch-phone.06e58cb0.png";